
import { ChevronDown, ChevronRight } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible";

interface NotificationItem {
  id: string;
  field: string;
  label: string;
  description: string;
}

interface NotificationSectionProps {
  title: string;
  description: string;
  items: NotificationItem[];
  isExpanded: boolean;
  onToggle: () => void;
  preferences: Record<string, boolean>;
  onPreferenceChange: (field: string, checked: boolean) => void;
  isUpdating: boolean;
}

export const NotificationSection = ({
  title,
  description,
  items,
  isExpanded,
  onToggle,
  preferences,
  onPreferenceChange,
  isUpdating,
}: NotificationSectionProps) => {
  return (
    <div className="border border-gray-100 rounded-lg shadow-sm">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer bg-gray-50 rounded-t-lg"
        onClick={onToggle}
      >
        <div>
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
        {isExpanded ? 
          <ChevronDown className="h-5 w-5 text-gray-500" /> : 
          <ChevronRight className="h-5 w-5 text-gray-500" />
        }
      </div>
      
      <Collapsible open={isExpanded}>
        <CollapsibleContent>
          <div className="space-y-4 p-4">
            {items.map(item => (
              <div key={item.id} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md">
                <div>
                  <Label htmlFor={item.id} className="text-base">{item.label}</Label>
                  <p className="text-sm text-gray-500">{item.description}</p>
                </div>
                <Switch 
                  id={item.id} 
                  checked={preferences[item.field]}
                  onCheckedChange={(checked) => onPreferenceChange(item.field, checked)}
                  disabled={isUpdating}
                />
              </div>
            ))}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};
